<template>
    <div class="row">
        <div class="col-12">
            <transition name="fade" mode="out-in">
                <div key="renmovar" id="renovar">
                    <RenovacionComponent 
                        @renovar="renovar" 
                        :precios="precios" 
                        @seleccionarZona="seleccionarZonaRenovacion"
                    />
                </div>
            </transition>
        </div>
        <div class="col-12 mt-4">
            <transition name="fade" mode="out-in">
                <div key="mapa" id="mapa">
                    <NuevasAltasComponent 
                        v-if="recargar && place.tipo_proceso_online == 1" 
                        :renovacion="renovacion" 
                        :zonas="zonas" 
                        @goTo="goTo" 
                        :place="place"
                    />

                    <template v-if="place.tipo_proceso_online == 2">
                        <SeleccionarRegionConSecciones
                            @terminar="goTo"
                        />
                    </template>

                    <template v-if="place.tipo_proceso_online == 3">
                        <h2>Compra mapa general</h2>
                    </template>
                </div>
            </transition>
        </div>
    </div>
</template>

<script>
    import NuevasAltasComponent from '@/components/backend/stepper/components/NuevasAltasComponent';
    import RenovacionComponent from '@/components/backend/stepper/components/RenovacionComponent';
    import SeleccionarRegionConSecciones from '../components/secciones/SeleccionarRegionConSecciones.vue';

    export default {
        props: ['precios'],
        data() {
            return {
                zonas: null,
                renovacion: 0,
                recargar: true
            }
        },
        created() {
            if(this.place.tipo_proceso_online == 1) {
                this.getZonas();
            }        
        },
        computed: {
            place() {
                return this.$store.getters.getRecinto;
            }
        },
        methods: {
            seleccionarZonaRenovacion() {
                this.renovacion = 1;
                this.recargar = false;
                this.$nextTick(() => {
                    this.recargar = true;
                });
                this.$scrollTo('#mapa');
            },
            goTo(paso, zona, abono) {
                this.$emit('goTo', paso, zona, abono);
            },
            getZonas() {
                const params = {
                    filters: {
                        renovacion: this.renovacion,
                        place_id: this.place.id
                    },
                }
                this.$store.dispatch(this.config.getVuexAlias('zonas.index'), params).then(res => {
                    this.zonas = res.data;
                    if (this.place) {
                        this.getZonasAnexas();
                    }
                });
            },
            renovar(abonado) {
                var paso = false;
                for(var i in this.zonas) {
                    if((abonado.asiento && this.zonas[i].id == abonado.asiento.region_id) || (abonado.plaza && this.zonas[i].id === abonado.plaza.region_id)) {
                        paso = true;
                        this.goTo(2, this.zonas[i], abonado);
                    }
                }

                if(!paso){
                    this.goTo(1, _, abonado);
                }
            },
            scrollTo(paso) {
                this.$scrollTo(paso, 100)
            },
            getZonasAnexas() {
                const params = {
                    filters: {},
                    lista_id: this.$store.getters.getListaId,
                    recinto_id: this.place.id
                }

                this.$store.dispatch(this.config.getVuexAlias('back.abonos.taquilla.regiones-anexas'), params).then(res => {
                    let anexas = res.data.data;

                    anexas.forEach(zona => {
                        zona.precios.forEach(precio => {
                            zona.precios = [];
                            zona.precios = zona.precios.concat(precio.descuentos);
                        });
                    });

                    this.zonas = this.zonas.concat(anexas);
                    this.$emit('setZonas', this.zonas);
                })
            }
        },
        components: {
            NuevasAltasComponent, RenovacionComponent, SeleccionarRegionConSecciones
        }
    }
</script>
